<div class="image-cropper-container">
  <image-cropper #imageCropper
    (imageCropped)="imageCropped($event)" 
    (imageLoaded)="imageLoaded()" 
    (cropperReady)="cropperReady()" 
    (loadImageFailed)="loadImageFailed($event)" 
    [(imageBase64)]="imageBase64"
    [maintainAspectRatio]="maintainAspectRatio" 
    [aspectRatio]="aspectRatio" 
    [resizeToWidth]="1920"
    [cropperMinWidth]="250" 
    [cropperMinHeight]="250" 
    [onlyScaleDown]="true" 
    [roundCropper]="false"
    format="jpeg" 
    outputType="base64" 
    [autoCrop]="autoCrop"></image-cropper>
</div>
<div class="d-flex">
  <button (click)="rotateLeft()" class="mr-1 btn btn-sm btn-primary btn-icon">
    <i class="mdi mdi-rotate-left"></i>
  </button>
  <button (click)="rotateRight()" class="mr-1 btn btn-sm btn-primary btn-icon">
    <i class="mdi mdi-rotate-right"></i>
  </button>

  <div class="btn-group mr-1">
    <button (click)="aspectRatio=1; maintainAspectRatio=false;" [ngClass]="{'active': maintainAspectRatio==false }" class="btn btn-primary btn-icon btn-sm">
      <i class="mdi mdi-crop-free"></i>
    </button>
    <button (click)="aspectRatio=4/3; maintainAspectRatio=true;" [ngClass]="{'active': aspectRatio==4/3 }" class="btn btn-primary btn-icon btn-sm">
      <i class="mdi mdi-crop-landscape"></i>
    </button>
    <button (click)="aspectRatio=3/4; maintainAspectRatio=true;" [ngClass]="{'active': aspectRatio==3/4 }" class="btn btn-primary btn-icon btn-sm">
      <i class="mdi mdi-crop-portrait"></i>
    </button>
    <button (click)="aspectRatio=1; maintainAspectRatio=true;" [ngClass]="{'active': maintainAspectRatio==true && aspectRatio==1 }" class="btn btn-primary btn-icon btn-sm">
      <i class="mdi mdi-crop-square"></i>
    </button>
  </div>

  <div class="input-group flex-nowrap mr-1">
    <div class="input-group-prepend">
      <button class="btn btn-sm btn-primary btn-icon" (click)="imgBrilho=100; setImageStyle()">
        <i class="mdi mdi-brightness-6"></i>
      </button>
      <div style="width:46px" class="input-group-text justify-content-center py-0 px-2">{{imgBrilho - 100}}%</div>
    </div>
    <div class="input-group-append input-group-text w-100 bg-white py-0 px-2">
      <input min="50" max="150" defaultValue="100" step="2" [(ngModel)]="imgBrilho" (ngModelChange)="setImageStyle()" type="range" name="" id="">
    </div>
  </div>

  <div class="input-group flex-nowrap mr-1">
    <div class="input-group-prepend">
      <button class="btn btn-sm btn-primary btn-icon" (click)="imgContraste=100; setImageStyle()">
        <i class="mdi mdi-contrast-box"></i>
      </button>
      <div style="width:46px" class="input-group-text justify-content-center py-0 px-2">{{imgContraste - 100}}%</div>
    </div>
    <div class="input-group-append input-group-text w-100 bg-white py-0 px-2">
      <input min="50" max="150" defaultValue="100" step="2" [(ngModel)]="imgContraste" (ngModelChange)="setImageStyle()" type="range" name="" id="">
    </div>
  </div>

</div>